import React, {useState} from 'react';
import {
  View,
  Text,
  StyleSheet,
  TextInput,
  ScrollView,
} from 'react-native';
import HeaderWithBack from '../../components/Header/headerWithBack';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { COLOR_BROWN, LIGHT_GREY, MAIN_HEADER_SUB_TITLE, MAIN_HEADER_TITLE } from '../../style';

const GHALogin = ({navigation}) => {
  const [loginFormData, setLoginFormData] = useState({
    email: '',
    password: '',
  });
  const [errors, setErrors] = useState({
    email: '',
    password: '',
  });

  const handleLoginSubmit = () => {
    let valid = true;

    if (loginFormData.email === '') {
      setErrors(prevErrors => ({
        ...prevErrors,
        email: 'Please enter your email.',
      }));
      valid = false;
    }
    if (loginFormData.password === '') {
      setErrors(prevErrors => ({
        ...prevErrors,
        password: 'Please enter your password.',
      }));
      valid = false;
    }

    if (valid) {
      console.log('Login successful', loginFormData);
      //  navigation or API call here
    }
  };
  const handleResetPress = () => {};

  const handleInputChange = (name, value) => {
    setLoginFormData({...loginFormData, [name]: value});
    // Clearing errors related to the changed field
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: '',
    }));
  };

  return (
    <View style={styles.ghaLoginContainer}>
      <HeaderWithBack navigation = {navigation}/>
      <ScrollView
        style={styles.contentContainer}
        showsVerticalScrollIndicator={false}>
        <ImageComp source={null} style={styles.image} />

        <Text style={styles.title}>
          <Text style={styles.titleBold}>LOG IN</Text> TO VICEROY DISCOVERY
          LOYALTY
        </Text>

        <View style={styles.loginInfoContainer}>
          <Text style={styles.loginInfoTitle}>Login information</Text>

          <Text style={styles.label}>Email Address</Text>
          <TextInput
            style={styles.input}
            placeholder="Enter Email"
            placeholderTextColor="gray"
            value={loginFormData.email}
            onChangeText={text => handleInputChange('email', text)}
          />
          {errors.email ? (
            <Text style={styles.errorText}>{errors.email}</Text>
          ) : null}

          <Text style={styles.label}>Password</Text>
          <TextInput
            style={styles.input}
            placeholder="Enter your password"
            placeholderTextColor="gray"
            value={loginFormData.password}
            onChangeText={text => handleInputChange('password', text)}
            secureTextEntry
          />
          {errors.password ? (
            <Text style={styles.errorText}>{errors.password}</Text>
          ) : null}

          <CustomPressable
            style={styles.loginButton}
            onPress={handleLoginSubmit}>
            <Text style={styles.loginButtonText}>LOG IN</Text>
          </CustomPressable>

          <CustomPressable
            style={styles.resetButton}
            onPress={handleResetPress}>
            <Text style={styles.resetButtonText}>RESET PASSWORD</Text>
          </CustomPressable>
        </View>
        <View style={styles.bottomSpacer} />
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  ghaLoginContainer: {
    flex: 1,
    backgroundColor: 'white',
  },
  image: {
    width: '100%',
    height: 230,
  },
  contentContainer: {
    marginHorizontal: 20,
  },
  title: {
    marginTop: 10,
    fontSize: 40,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 30,
    marginHorizontal: 20,
    fontFamily: MAIN_HEADER_TITLE
  },
  titleBold: {
    fontWeight: 'bold',
    color: COLOR_BROWN,
  },
  loginInfoContainer: {
    backgroundColor: LIGHT_GREY,
    padding: 20,
  },
  loginInfoTitle: {
    fontSize: 22,
    fontWeight: '500',
    marginBottom: 25,
    marginTop: 10,
    fontFamily: MAIN_HEADER_SUB_TITLE
  },
  label: {
    fontSize: 14,
    marginBottom: 5,
    fontWeight: '500',
    fontFamily: MAIN_HEADER_SUB_TITLE
  },
  input: {
    borderWidth: 1,
    borderColor: '#000',
    paddingHorizontal: 10,
    fontSize: 18,
    paddingVertical: 13,
    marginBottom: 5,
    fontFamily: MAIN_HEADER_SUB_TITLE
  },
  loginButton: {
    backgroundColor: '#000',
    paddingVertical: 15,
    alignItems: 'center',
    marginBottom: 10,
    marginTop: 10,
  },
  loginButtonText: {
    color: 'white',
    fontSize: 20,
    fontWeight: 'bold',
    fontFamily: MAIN_HEADER_TITLE
  },
  resetButton: {
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#000',
    paddingVertical: 15,
    alignItems: 'center',
  },
  resetButtonText: {
    color: 'black',
    fontSize: 20,
    fontWeight: 'bold',
    fontFamily: MAIN_HEADER_TITLE
  },
  bottomSpacer: {
    height: 60,
  },
  errorText: {
    color: 'red',
    fontFamily: MAIN_HEADER_SUB_TITLE,
    fontSize: 12,
    marginBottom: 10,
  },
});

export default GHALogin;
